import { Box, Hint } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

export interface HintProps {
  handleClose: () => void
}

export const KanbanViewHint = ({ handleClose }: HintProps) => {
  useEffect(() => {
    track(trackingEvents.projectManagement.hints.viewKanbanSelectorHint)
  }, [])

  const handleHintClose = () => {
    handleClose()
    track(trackingEvents.projectManagement.hints.closeKanbanSelectorHint)
  }

  return (
    <Hint.Popover.Provider steps={1} onClose={handleHintClose} onFinish={handleHintClose}>
      <Box position="relative" alignSelf="end" paddingBottom="s32" paddingLeft="s16">
        <Hint.Popover
          step={1}
          title={i18n.t('project_management.hints.kanban_view.title')}
          description={i18n.t('project_management.hints.kanban_view.description')}
          position="left bottom"
        />
      </Box>
    </Hint.Popover.Provider>
  )
}
